// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"253957c0","990":"387f1c62"}[chunkId] + ".chunk.js";
};